import styled from 'styled-components';
import { Button, Radio, Rate } from 'antd';

const COLORS = {
	BLUE: '#2F54EB',
	BLUE_ALTERNATE: '#3856f8',
	LIGHT_BLUE: '#eaeefd'
};

const FIELDS_HEIGHT = '2.4rem';

export const RateWrapper = styled(Rate)`
	width: 100%;
	display: flex;
	&& .ant-rate-star Button {
		padding: 14px 14px;
		width: 100px;
		transition: all 0.3s ease;
		border-radius: 6px !important;
		color: ${({ theme }) => theme.palette.secondary['400']};
		border: 1px solid ${({ theme }) => theme.palette.secondary['200']};
	}

	&& .ant-rate-star.ant-rate-star-full button {
		border: none;
		width: 100px;
		color: ${COLORS.BLUE_ALTERNATE};
		border: 1px solid ${COLORS.LIGHT_BLUE};
		background-color: ${COLORS.LIGHT_BLUE};
	}
`;

export const RateButton = styled(Button)`
	color: unset;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	height: ${FIELDS_HEIGHT};

	gap: 0.5rem;

	svg {
		width: 0.6rem;
	}
`;

export const Group = styled(Radio.Group)`
	width: 100%;

	.ant-radio-button-wrapper-checked {
		&:first-child {
			border: none;
			color: ${COLORS.BLUE};
		}
	}
`;
